export const paymentIsValid = (creditCard) => {
  if (!creditCard) return false;
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth() + 1;

  if (creditCard.expYear < currentYear) return false;
  if (creditCard.expYear === currentYear && creditCard.expMonth < currentMonth) return false;

  return true;
}